import { render } from "./AccountSettingMariana.vue?vue&type=template&id=fc061ca0"
import script from "./AccountSettingMariana.vue?vue&type=script&lang=js"
export * from "./AccountSettingMariana.vue?vue&type=script&lang=js"

import "./AccountSettingMariana.vue?vue&type=style&index=0&id=fc061ca0&lang=scss"
script.render = render

export default script